import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './FAQSection.css';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "س: كيف يمكن أن أتحقق أن التقرير صادر من منصة بيان بدون أي عبث؟",
      answer: "ج: توفر منصة بيان خدمة مجانية للتحقق من صحة التقارير. منصة بيان لا تحتفظ بالتقارير بعد تسليمها لصاحب الطلب، بالتالي يمكن فقط إعلام المستفيد أن التقرير سليم أو غير سليم بدون تحديد معلومات معينة غير دقيقة."
    },
    {
      id: 2,
      question: "س: ما هي حقوقي كصاحب بيانات؟",
      answer: "كصاحب بيانات، لك الحق في الوصول إلى بياناتك الشخصية، وطلب تصحيحها أو حذفها، والحصول على نسخة من بياناتك، والاعتراض على معالجة بياناتك في ظروف معينة، وفقاً لقانون حماية البيانات المعمول به."
    },
    {
      id: 3,
      question: "س: ما هي مدة صلاحية التقرير؟",
      answer: "تختلف مدة صلاحية التقرير حسب نوع البيانات والغرض من الاستخدام. عادة ما تكون التقارير صالحة لمدة 6 أشهر من تاريخ الإصدار، وقد تختلف هذه المدة حسب متطلبات الجهة المستفيدة."
    },
    {
      id: 4,
      question: "س: ما هو الإجراء المناسب إذا أراد صاحب البيانات تقديم اعتراض على دقة البيانات؟",
      answer: "في حالة الاعتراض على دقة البيانات، يمكن تقديم طلب مراجعة من خلال منصة بيان مع إرفاق المستندات الداعمة. سيتم مراجعة الطلب من قبل فريق مختص والرد خلال 5 أيام عمل مع تصحيح أي أخطاء مؤكدة."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">
            الأسئلة الشائعة
          </h2>
        </div>

        <div className="faq-list">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`faq-item ${openFAQ === faq.id ? 'open' : ''}`}
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="faq-question"
              >
                <div className="faq-icon">
                  {openFAQ === faq.id ? (
                    <ChevronUp className="faq-chevron" />
                  ) : (
                    <ChevronDown className="faq-chevron" />
                  )}
                </div>
                <span className="faq-question-text">{faq.question}</span>
              </button>
              
              <div className="faq-answer">
                <p className="faq-answer-text">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;